<template>
  <div class="charts">

    <!-- <div class="row">
      <div class="flex md6 xs12">
        <va-card
          class="chart-widget"
          :title="$t('dashboard.charts.quantityAprovedAndRefused')"
        >
          <va-chart v-if="AprovedAndRefusedLoaded" :data="AprovedAndRefused" type="vertical-bar"/>
        </va-card>
      </div>

      <div class="flex md6 xs12">
        <va-card
          class="chart-widget"
          :title="$t('dashboard.charts.quantityByErrorTypes')"
        >
          <va-chart v-if="QuantityByErrorTypesLoaded" :data="QuantityByErrorTypes" type="horizontal-bar"/>
        </va-card>
      </div>
    </div> -->

    <!-- <div class="row"> -->
      <!-- <div class="flex md6 xs12">
        <va-card
          class="chart-widget"
          :title="$t('dashboard.charts.quantityBoxesAndWeight')"
        >
          <va-chart v-if="QuantityByErrorTypesLoaded" :data="QuantityBoxesAndWeight" type="line"/>
        </va-card>
      </div> -->
    <!-- </div> -->

    <div class="row">

      <div class="flex md4 xs12">
        <va-card
          class="chart-widget"
          :title="$t('dashboard.charts.assembledOrder')"
        >
          <va-chart v-if="AssembledOrderLoaded" :data="AssembledOrder" type="pie"/>
        </va-card>
      </div>

      <div class="flex md4 xs12">
        <va-card
          class="chart-widget"
          :title="$t('dashboard.charts.checkedOrder')"
        >
          <va-chart v-if="CheckedOrderLoaded" :data="CheckedOrder" type="pie"/>
        </va-card>
      </div>

      <div class="flex md4 xs12">
        <va-card
          class="chart-widget"
          :title="$t('dashboard.charts.stackedOrder')"
        >
          <va-chart v-if="StackedOrderLoaded" :data="StackedOrder" type="pie"/>
        </va-card>
      </div>

    </div>

  </div>
</template>

<script>

import IndicatoresAPI from '@/services/IndicatoresAPI'
import { EventBus } from '@/event-bus'
import { mapState } from "vuex";

export default {
  data () {
    return {
      AprovedAndRefusedLoaded: false,
      AprovedAndRefused: {},

      QuantityByErrorTypes: {},
      QuantityByErrorTypesLoaded: false,

      QuantityBoxesAndWeight: {},
      QuantityBoxesAndWeightLoaded: false,

      AssembledOrder: {},
      AssembledOrderLoaded: false,

      CheckedOrder: {},
      CheckedOrderLoaded: false,

      StackedOrder: {},
      StackedOrderLoaded: false
    }
  },

  computed: {
    ...mapState(['currentLocality']),
  },

  methods: {
    async readItems(date){
      await IndicatoresAPI.getOrdersApprovedAndRefused(date, this.currentLocality.id).then(response => {
      this.AprovedAndRefused = response.data.datasets

      // formata as cores do gráfico antes de exibir
      this.AprovedAndRefused.datasets[0].label = "Aprovados"
      this.AprovedAndRefused.datasets[0].backgroundColor = "green"
      this.AprovedAndRefused.datasets[0].borderColor = "transparent"

      this.AprovedAndRefused.datasets[1].label = "Recusados"
      this.AprovedAndRefused.datasets[1].backgroundColor = "red"
      this.AprovedAndRefused.datasets[1].borderColor = "transparent"

      this.AprovedAndRefusedLoaded = true
    })

      await IndicatoresAPI.getAssembled(date, this.currentLocality.id).then(response => {
        this.AssembledOrder = response.data.datasets

        this.AssembledOrder.datasets[0].backgroundColor = [["green"], ["red"]]

        this.AssembledOrderLoaded = true
      })

      await IndicatoresAPI.getChecked(date, this.currentLocality.id).then(response => {
        this.CheckedOrder = response.data.datasets

        this.CheckedOrder.datasets[0].backgroundColor = [["green"], ["red"] ]

        this.CheckedOrderLoaded = true
      })

      await IndicatoresAPI.getStacked(date, this.currentLocality.id).then(response => {
        this.StackedOrder = response.data.datasets

        this.StackedOrder.datasets[0].backgroundColor = [["green"], ["red"]]

        this.StackedOrderLoaded = true

    })

      await IndicatoresAPI.getLastOrdersErrors(date, this.currentLocality.id).then(response => {
        this.QuantityByErrorTypes = response.data.datasets

        // formata as cores do gráfico antes de exibir
        this.QuantityByErrorTypes.datasets[0].label = "Sobra"
        this.QuantityByErrorTypes.datasets[0].backgroundColor = "#FFC200"
        this.QuantityByErrorTypes.datasets[0].borderColor = "transparent"

        this.QuantityByErrorTypes.datasets[1].label = "Falta"
        this.QuantityByErrorTypes.datasets[1].backgroundColor = "#000000"
        this.QuantityByErrorTypes.datasets[1].borderColor = "transparent"

        this.QuantityByErrorTypes.datasets[2].label = "Inversão"
        this.QuantityByErrorTypes.datasets[2].backgroundColor = "#34495E"
        this.QuantityByErrorTypes.datasets[2].borderColor = "transparent"

        this.QuantityByErrorTypes.datasets[3].label = "Avaria"
        this.QuantityByErrorTypes.datasets[3].backgroundColor = "#CB022A"
        this.QuantityByErrorTypes.datasets[3].borderColor = "transparent"

        this.QuantityByErrorTypes.datasets[4].label = "Não listado"
        this.QuantityByErrorTypes.datasets[4].backgroundColor = "#81cb02"
        this.QuantityByErrorTypes.datasets[4].borderColor = "transparent"

        this.QuantityByErrorTypes.datasets[5].label = "Contagem a Mais"
        this.QuantityByErrorTypes.datasets[5].backgroundColor = "#0902cb"
        this.QuantityByErrorTypes.datasets[5].borderColor = "transparent"

        this.QuantityByErrorTypes.datasets[6].label = "Contagem a Menos"
        this.QuantityByErrorTypes.datasets[6].backgroundColor = "#b002cb"
        this.QuantityByErrorTypes.datasets[6].borderColor = "transparent"

        this.QuantityByErrorTypesLoaded = true
      })

      await IndicatoresAPI.getLastBoxesAndWeight(date, this.currentLocality.id).then(response => {
        this.QuantityBoxesAndWeight = response.data.datasets

        // formata as cores do gráfico antes de exibir
        this.QuantityBoxesAndWeight.datasets[0].label = "Caixas"
        this.QuantityBoxesAndWeight.datasets[0].backgroundColor = '#000000'
        this.QuantityBoxesAndWeight.datasets[0].borderColor = "transparent"

        this.QuantityBoxesAndWeight.datasets[1].label = "Peso"
        this.QuantityBoxesAndWeight.datasets[1].backgroundColor = "#CB022A"
        this.QuantityBoxesAndWeight.datasets[1].borderColor = "transparent"

        this.QuantityBoxesAndWeightLoaded = true
      })
    }
  },

  mounted () {
    this.readItems('');

    EventBus.$on('dashborad_delivery_date_changed', new_date => {
      this.readItems(new_date)
    });
  },

  beforeDestroy(){
    EventBus.$off('dashborad_delivery_date_changed');
  }
}
</script>

<style scoped>
  .chart {
    height: 400px;
  }
</style>
